export default function TempoUnavailableDS() {
  return (
    <div className="p-4">
      <h2 className="text-2xl">Delivery Setting is temporary unavailable.</h2>
    </div>
  );
}
